import React from 'react';

/**
 * ErrorBoundary Global - Previne tela branca total
 * Captura erros de render em qualquer componente filho
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Erro capturado:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
    
    // Se estiver em produção, pode enviar para serviço de monitoramento
    // ex: Sentry, LogRocket, etc
    if (process.env.NODE_ENV === 'production') {
      // logErrorToService(error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8fafc',
          padding: '2rem',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          <div style={{
            maxWidth: '600px',
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '2rem',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            border: '1px solid #e5e7eb'
          }}>
            {/* Logo */}
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <div style={{
                display: 'inline-block',
                width: '64px',
                height: '64px',
                backgroundColor: '#111111',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'white'
              }}>
                AS
              </div>
            </div>

            {/* Título */}
            <h1 style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: '#111111',
              marginBottom: '0.5rem',
              textAlign: 'center'
            }}>
              Ops! Algo deu errado
            </h1>

            {/* Mensagem */}
            <p style={{
              color: '#6b7280',
              marginBottom: '1.5rem',
              textAlign: 'center',
              fontSize: '0.95rem'
            }}>
              Arena Stats encontrou um erro inesperado. Por favor, recarregue a página.
            </p>

            {/* Botão Reload */}
            <button 
              onClick={this.handleReload}
              style={{
                width: '100%',
                backgroundColor: '#111111',
                color: 'white',
                padding: '12px 24px',
                borderRadius: '8px',
                border: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                marginBottom: '1rem',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#0b0b0c'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#111111'}
            >
              🔄 Recarregar Página
            </button>

            {/* Detalhes do Erro (collapsible) */}
            {this.state.error && (
              <details style={{
                marginTop: '1rem',
                padding: '1rem',
                backgroundColor: '#fef2f2',
                borderRadius: '8px',
                border: '1px solid #fecaca',
                fontSize: '0.875rem'
              }}>
                <summary style={{
                  cursor: 'pointer',
                  fontWeight: '600',
                  color: '#dc2626',
                  marginBottom: '0.5rem'
                }}>
                  Detalhes técnicos (para desenvolvedores)
                </summary>
                <div style={{
                  fontFamily: 'monospace',
                  fontSize: '0.8rem',
                  color: '#991b1b',
                  whiteSpace: 'pre-wrap',
                  marginTop: '0.5rem'
                }}>
                  <strong>Erro:</strong> {this.state.error.toString()}
                  {this.state.errorInfo && (
                    <>
                      <br /><br />
                      <strong>Stack:</strong>
                      <br />
                      {this.state.errorInfo.componentStack}
                    </>
                  )}
                </div>
              </details>
            )}

            {/* Link de Suporte */}
            <p style={{
              marginTop: '1.5rem',
              textAlign: 'center',
              fontSize: '0.875rem',
              color: '#9ca3af'
            }}>
              Se o problema persistir, entre em contato com{' '}
              <a 
                href="/contato" 
                style={{ color: '#b48c2c', textDecoration: 'underline' }}
              >
                suporte
              </a>
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
